/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "í gjár",
        "-2": "fyrradagin",
        "0": "í dag",
        "1": "í morgin",
        "2": "í ovurmorgin",
        "future": {
          "one": "um {0} dag",
          "other": "um {0} dagar"
        },
        "past": {
          "one": "{0} dagur síðan",
          "other": "{0} dagar síðan"
        }
      },
      "day-narrow": {
        "-1": "í gjár",
        "-2": "fyrradagin",
        "0": "í dag",
        "1": "í morgin",
        "2": "í ovurmorgin",
        "future": {
          "one": "um {0} d.",
          "other": "um {0} d."
        },
        "past": {
          "one": "{0} d. síðan",
          "other": "{0} d. síðan"
        }
      },
      "day-short": {
        "-1": "í gjár",
        "-2": "fyrradagin",
        "0": "í dag",
        "1": "í morgin",
        "2": "í ovurmorgin",
        "future": {
          "one": "um {0} da.",
          "other": "um {0} da."
        },
        "past": {
          "one": "{0} da. síðan",
          "other": "{0} da. síðan"
        }
      },
      "hour": {
        "0": "hendan tíman",
        "future": {
          "one": "um {0} tíma",
          "other": "um {0} tímar"
        },
        "past": {
          "one": "{0} tími síðan",
          "other": "{0} tímar síðan"
        }
      },
      "hour-narrow": {
        "0": "hendan tíman",
        "future": {
          "one": "um {0} t.",
          "other": "um {0} t."
        },
        "past": {
          "one": "{0} t. síðan",
          "other": "{0} t. síðan"
        }
      },
      "hour-short": {
        "0": "hendan tíman",
        "future": {
          "one": "um {0} t.",
          "other": "um {0} t."
        },
        "past": {
          "one": "{0} t. síðan",
          "other": "{0} t. síðan"
        }
      },
      "minute": {
        "0": "hendan minuttin",
        "future": {
          "one": "um {0} minutt",
          "other": "um {0} minuttir"
        },
        "past": {
          "one": "{0} minutt síðan",
          "other": "{0} minuttir síðan"
        }
      },
      "minute-narrow": {
        "0": "hendan minuttin",
        "future": {
          "one": "um {0} m.",
          "other": "um {0} m."
        },
        "past": {
          "one": "{0} m. síðan",
          "other": "{0} m. síðan"
        }
      },
      "minute-short": {
        "0": "hendan minuttin",
        "future": {
          "one": "um {0} min.",
          "other": "um {0} min."
        },
        "past": {
          "one": "{0} min. síðan",
          "other": "{0} min. síðan"
        }
      },
      "month": {
        "-1": "seinasta mánað",
        "0": "henda mánaðin",
        "1": "næsta mánað",
        "future": {
          "one": "um {0} mánað",
          "other": "um {0} mánaðir"
        },
        "past": {
          "one": "{0} mánað síðan",
          "other": "{0} mánaðir síðan"
        }
      },
      "month-narrow": {
        "-1": "seinasta mnð.",
        "0": "henda mnð.",
        "1": "næsta mnð.",
        "future": {
          "one": "um {0} mnð.",
          "other": "um {0} mnð."
        },
        "past": {
          "one": "{0} mnð. síðan",
          "other": "{0} mnð. síðan"
        }
      },
      "month-short": {
        "-1": "seinasta mnð.",
        "0": "henda mnð.",
        "1": "næsta mnð.",
        "future": {
          "one": "um {0} mnð.",
          "other": "um {0} mnð."
        },
        "past": {
          "one": "{0} mnð. síðan",
          "other": "{0} mnð. síðan"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "seinasta ársfjórðing",
        "0": "hendan ársfjórðingin",
        "1": "næsta ársfjórðing",
        "future": {
          "one": "um {0} ársfjórðing",
          "other": "um {0} ársfjórðingar"
        },
        "past": {
          "one": "{0} ársfjórðing síðan",
          "other": "{0} ársfjórðingar síðan"
        }
      },
      "quarter-narrow": {
        "-1": "seinasta ársfjórðing",
        "0": "hendan ársfjórðingin",
        "1": "næsta ársfjórðing",
        "future": {
          "one": "um {0} ársfj.",
          "other": "um {0} ársfj."
        },
        "past": {
          "one": "{0} ársfj. síðan",
          "other": "{0} ársfj. síðan"
        }
      },
      "quarter-short": {
        "-1": "seinasta ársfjórðing",
        "0": "hendan ársfjórðingin",
        "1": "næsta ársfjórðing",
        "future": {
          "one": "um {0} ársfj.",
          "other": "um {0} ársfj."
        },
        "past": {
          "one": "{0} ársfj. síðan",
          "other": "{0} ársfj. síðan"
        }
      },
      "second": {
        "0": "nú",
        "future": {
          "one": "um {0} sekund",
          "other": "um {0} sekund"
        },
        "past": {
          "one": "{0} sekund síðan",
          "other": "{0} sekund síðan"
        }
      },
      "second-narrow": {
        "0": "nú",
        "future": {
          "one": "um {0} s.",
          "other": "um {0} s."
        },
        "past": {
          "one": "{0} s. síðan",
          "other": "{0} s. síðan"
        }
      },
      "second-short": {
        "0": "nú",
        "future": {
          "one": "um {0} sek.",
          "other": "um {0} sek."
        },
        "past": {
          "one": "{0} sek. síðan",
          "other": "{0} sek. síðan"
        }
      },
      "week": {
        "-1": "seinastu viku",
        "0": "hesu viku",
        "1": "næstu viku",
        "future": {
          "one": "um {0} viku",
          "other": "um {0} vikur"
        },
        "past": {
          "one": "{0} vika síðan",
          "other": "{0} vikur síðan"
        }
      },
      "week-narrow": {
        "-1": "seinastu v.",
        "0": "hesu v.",
        "1": "næstu v.",
        "future": {
          "one": "um {0} v.",
          "other": "um {0} v."
        },
        "past": {
          "one": "{0} v. síðan",
          "other": "{0} v. síðan"
        }
      },
      "week-short": {
        "-1": "seinastu vi.",
        "0": "hesu vi.",
        "1": "næstu vi.",
        "future": {
          "one": "um {0} vi.",
          "other": "um {0} vi."
        },
        "past": {
          "one": "{0} vi. síðan",
          "other": "{0} vi. síðan"
        }
      },
      "year": {
        "-1": "í fjør",
        "0": "í ár",
        "1": "næsta ár",
        "future": {
          "one": "um {0} ár",
          "other": "um {0} ár"
        },
        "past": {
          "one": "{0} ár síðan",
          "other": "{0} ár síðan"
        }
      },
      "year-narrow": {
        "-1": "í fjør",
        "0": "í ár",
        "1": "næsta ár",
        "future": {
          "one": "um {0} ár",
          "other": "um {0} ár"
        },
        "past": {
          "one": "{0} ár síðan",
          "other": "{0} ár síðan"
        }
      },
      "year-short": {
        "-1": "í fjør",
        "0": "í ár",
        "1": "næsta ár",
        "future": {
          "one": "um {0} ár",
          "other": "um {0} ár"
        },
        "past": {
          "one": "{0} ár síðan",
          "other": "{0} ár síðan"
        }
      }
    },
    "locale": "fo"
  });
}